import { FC } from 'react';
import { Quill } from 'react-quill';
import redo from '../../../assets/icons/redo.svg';
import undo from '../../../assets/icons/undo.svg';

interface QuillInstance {
	// eslint-disable-next-line @typescript-eslint/ban-ts-comment
	// @ts-ignore
	quill: Quill;
}

function undoChange(this: QuillInstance) {
	this.quill.history.undo();
}

function redoChange(this: QuillInstance) {
	this.quill.history.redo();
}

const Size = Quill.import('formats/size');

Size.whitelist = ['extra-small', 'small', 'medium', 'large'];
Quill.register(Size, true);

const Font = Quill.import('formats/font');

Font.whitelist = ['arial', 'comic-sans', 'courier-new', 'georgia', 'helvetica', 'lucida'];
Quill.register(Font, true);

export const modules = {
	toolbar: {
		container: '#toolbar',
		handlers: {
			undo: undoChange,
			redo: redoChange,
		},
	},
	history: {
		delay: 500,
		maxStack: 100,
		userOnly: true,
	},
};

export const formats: string[] = [
	'font',
	'bold',
	'italic',
	'underline',
	'strike',
	// 'color',
	'background',
	'list',
	'bullet',
	'link',
];

export const QuillToolbar: FC = () => (
	<div id="toolbar">
		<span className="ql-formats">
			<button className="ql-undo">
				<img src={undo} alt="" />
			</button>
			<button className="ql-redo">
				<img src={redo} alt="" />
			</button>
		</span>
		<span className="ql-formats">
			<select className="ql-font" defaultValue="arial">
				<option value="arial">Arial</option>
				<option value="comic-sans">Comic Sans</option>
				<option value="courier-new">Courier New</option>
				<option value="georgia">Georgia</option>
				<option value="helvetica">Helvetica</option>
				<option value="lucida">Lucida</option>
			</select>
		</span>
		<span className="ql-formats">
			<select className="ql-align" />
			{/* <select className="ql-color" /> */}
			{/* <select className="ql-background" /> */}
		</span>
		<span className="ql-formats">
			<button className="ql-bold" />
			<button className="ql-italic" />
			<button className="ql-underline" />
			<button className="ql-strike" />
		</span>
		<span className="ql-formats">
			<button className="ql-link" />
		</span>
		<span className="ql-formats">
			<button className="ql-list" value="ordered" />
			<button className="ql-list" value="bullet" />
		</span>
	</div>
);

export default QuillToolbar;
